@if (freezeState.isFrozen) {
    <div class="freeze" [@slideIn]>
        <div class="freeze__content">
            <h2 class="freeze__title">Access Temporarily Restricted</h2>
            <p class="freeze__message">{{ freezeState.message }}</p>
            <div class="freeze__spinner">
                <div class="freeze__spinner-border" role="status">
                    <span class="freeze__sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </div>
}
